/* eslint-disable no-extra-parens */
import React, { Suspense, useEffect, useState, ReactNode } from 'react';

import { IStoreState } from '../interfaces/types';
import { reduxConnect } from '../../../common';
import { PageIdsForPagesWithWidgetType, isPageWithWidget } from './pagesWithWidgets';

interface StoryWidgetLazyProps {
    pageId: string;
    children: ReactNode;
    suspenseFallbackLoadingUI: ReactNode;
}

const mapStoreStateToProps = (storeState: IStoreState) => {
    const { appState } = storeState || {};
    const { pageId } = appState?.appState || {};

    return {
        pageId
    };
};

const mapDispatchToProps = {};

export const WidgetLazyLoadWrapper = reduxConnect( mapStoreStateToProps, mapDispatchToProps )(({ 
    pageId, 
    children, 
    suspenseFallbackLoadingUI }: StoryWidgetLazyProps) => {
    const [isMounted, setIsMounted] = useState(false);

    useEffect(() => {
        if (!isMounted && pageId && isPageWithWidget(pageId as PageIdsForPagesWithWidgetType)) {
            setIsMounted(true);
        }
    }, [pageId, isMounted]);

    if (!isMounted) {
        return null;
    }

    return (
        <Suspense fallback={suspenseFallbackLoadingUI}>
            {children}
        </Suspense>
    );
});